const adminFunctionConstants = {
    CONFIGURATION_TAB : 'Configuration',

    USERS_TAB : 'Users',

    ORGANIZATIONS_TAB : 'Organizations',

    NOTIFICATIONS_TAB : 'Notifications',

    PERMISSIONS_TAB : 'Permissions',

    CONFIGURATION_SCORING : 'Scoring',

    PREFERENCES_TAB : 'Preferences',

    CONFIGURATION_PRODUCTS : 'Products',

    CONFIGURATION_SECTIONS : 'Sections',

    CONFIGURATION_RULES : 'Rules',

    CONFIGURATION_DATA_SETS : 'Data Sets',

    CONFIGURATION_FORMS : 'Forms',

    CONFIGURATION_SCORING_RULES : 'Scoring Rules',

    CONFIGURATION_RATE_STATUS : 'Rate Status',

    USERS_USER_GROUPS : 'User Groups',

    SYSTEM_USERS : 'System Users',

    SERVICE_TEAM_USERS : 'Service Users',

    USERS_UNDERWRITERS : 'Underwriters',

    USERS_AGENCY_BROKERAGE_USERS : 'Agency/Brokerage Users',

    ORGANIZATIONS_MGA_ORGANIZATION : 'MGA',

    ORGANIZATIONS_CARRIER_ORGANIZATION : 'Carrier',

    ORGANIZATIONS_MGA_AGENCY_BROKERAGE : 'MGA Agency/Brokerage',

    ORGANIZATIONS_AGENCY_BROKERAGE : 'Agency/Brokerage',

    NOTIFICATIONS_POP_UP : 'Pop-up',

    NOTIFICATIONS_EMAIL : 'Email',

    PERMISSIONS_AGENCY_BROKERAGE : 'Agency/Brokerage',

    PERMISSIONS_SERVICE_TEAM : 'Service Team',

    PERMISSIONS_UNDERWRITING : 'Underwriting',

    PERMISSIONS_SYSTEM : 'System',

    PREFERENCES_GENERAL : 'General',

    PREFERENCES_TABLE_COLUMNS : 'Table Columns',

    PREFERENCES_FILES_AND_ICONS : 'Files & Icons'

};

angular.module('gw-um-j2js')
    .constant('adminFunctionConstants', adminFunctionConstants);